/**
 * Auth Service - Backward compatibility shim
 *
 * This service reads from localStorage which is kept in sync by SupabaseAuthContext.
 * It exists for non-React code and components that haven't been migrated to useSupabaseAuth() yet.
 *
 * Prefer using useSupabaseAuth() hook in React components.
 */
import { supabase } from '../config/supabase';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const authService = {
  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    try {
      return JSON.parse(userStr);
    } catch (e) {
      return null;
    }
  },

  isAuthenticated() {
    const user = this.getCurrentUser();
    return !!user && !!user.token;
  },

  async logout() {
    try { await supabase.auth.signOut(); } catch (e) { /* ignore */ }
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    sessionStorage.clear();
  },

  async getProfile() {
    const token = this.getCurrentUser()?.token || localStorage.getItem('token');
    if (!token) throw new Error('Not authenticated');
    const response = await fetch(`${API_URL}/api/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Failed to fetch profile');
    return response.json();
  },

  async updateProfile(data) {
    const token = this.getCurrentUser()?.token || localStorage.getItem('token');
    if (!token) throw new Error('Not authenticated');
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) formData.append(key, value);
    });
    const response = await fetch(`${API_URL}/api/auth/me`, {
      method: 'PUT',
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    });
    if (!response.ok) throw new Error('Failed to update profile');
    return response.json();
  },
};

export default authService;
